(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
'use strict';

document.addEventListener('DOMContentLoaded', evt => {
    const navMain = require('./modules/nav.js').init;
    const navToc = require('./modules/nav-toc.js');
    const forms = require('./modules/form.js');
    const FormatHumanDate = require('./modules/format-date.js');
    const contenttables = require('./modules/contenttable.js');
    const accordions = require('./modules/accordion.js');
    const share = require('./modules/share.js');
    const isSmallScreen = require('./utils/is-smallscreen.js');
    const dialog = require('./modules/dialog.js');
    const facets = require('./modules/facets.js');
    const scrollTop = require('./modules/scroll-top.js').init;
    const menuActions = require('./modules/menu-actions.js').init;

    document.querySelector('html').classList.remove('no-js');
    document.querySelector('html').classList.add('js');

    // CSS features detection
    if (!window.getComputedStyle(document.querySelector('img')).objectFit) {
        document.querySelector('html').classList.add('no-objectFit');
    }

    // Main navigation
    navMain();

    // Set a global property to get the html[lang] value
    Object.defineProperty(window, 'LANG', { value: document.querySelector('html').getAttribute('lang') });

    // Forms
    forms.init();
    FormatHumanDate.init();

    // Contenttable tables
    contenttables.init();

    // Accordions
    accordions.init();

    // TOC navigation
    navToc.init();

    // Share content to social media
    share.init();

    // Facets
    if (document.querySelector('#facets')) {
        facets.init();
    }

    // Show/Hide the ScrollTop button
    scrollTop();

    // Actions menu
    menuActions();
});
//

},{"./modules/accordion.js":2,"./modules/contenttable.js":3,"./modules/dialog.js":4,"./modules/facets.js":5,"./modules/form.js":6,"./modules/format-date.js":7,"./modules/menu-actions.js":8,"./modules/nav-toc.js":9,"./modules/nav.js":10,"./modules/scroll-top.js":11,"./modules/share.js":12,"./utils/is-smallscreen.js":20}],2:[function(require,module,exports){
// Accordion module
// Add an [aria-hidden="false"] attribute to the [data-js-accordion="panel"] elements to have the accordion opened by default.
const Accordion = (function() {
    const matches = require('../utils/matches.js');
    const accordions = Array.prototype.slice.call(
        document.querySelectorAll('[data-js-accordion="item"]')
    );

    // Switch between accordion visible/hidden states
    const toggleAccordion = (trigger, accordion) => {
        const panel = document.getElementById(trigger.getAttribute('aria-controls'));

        if (trigger.getAttribute('aria-expanded') == 'true') {
            trigger.setAttribute('aria-expanded', 'false');

            panel.hidden = true;
            panel.setAttribute('aria-hidden', 'true');
            panel.setAttribute('tabindex', '-1');
            panel.style.height = null;

            accordion.classList.remove('accordion--expanded');
        } else {
            trigger.setAttribute('aria-expanded', 'true');

            panel.hidden = false;
            panel.setAttribute('aria-hidden', 'false');
            panel.setAttribute('tabindex', '0');
            panel.style.height = accordion.dataset.panelHeight;

            accordion.classList.add('accordion--expanded');
        }

        return;
    };

    // Set the trigger button
    const setAccordionTrigger = (accordion) => {
        const header = accordion.querySelector('[data-js-accordion="header"]');
        const trigger = document.createElement('button');
        const panel = accordion.querySelector('[data-js-accordion="panel"]');

        trigger.classList.add('accordion__trigger');
        trigger.dataset.jsAccordion = 'trigger';
        trigger.id = `${accordion.id}_trigger`;
        trigger.innerHTML = header.innerHTML;
        trigger.setAttribute('aria-controls', `${accordion.id}_panel`);
        trigger.setAttribute('type', 'button');

        // if the panel is set to be open by default
        if (panel.getAttribute('aria-hidden') === 'false') {
            trigger.setAttribute('aria-expanded', 'true');
        } else {
            trigger.setAttribute('aria-expanded', 'false');
        }

        trigger.addEventListener('click', evt => toggleAccordion(evt.target, accordion));

        header.innerHTML = '';

        return header.appendChild(trigger);
    };

    // Set the panel element
    const setAccordionPanel = (accordion, defaultHeight) => {
        const panel = accordion.querySelector('[data-js-accordion="panel"]');

        panel.setAttribute('aria-labelledby', `${accordion.id}_trigger`);
        panel.setAttribute('role', 'region');

        // To be open by default set [aria-hidden] to false
        // Otherwise
        if (panel.getAttribute('aria-hidden') !== 'false') {
            panel.setAttribute('aria-hidden', 'true');
            panel.setAttribute('hidden', '');
            panel.setAttribute('tabindex', '-1');
        } else {
            panel.style.height = defaultHeight;
        }

        return panel;
    };

    const init = () => {
        return accordions.forEach(accordion => {
            const initialHeight = accordion.offsetHeight;

            accordion.dataset.panelHeight = `${initialHeight}px`;

            setAccordionTrigger(accordion);
            setAccordionPanel(accordion, accordion.dataset.panelHeight);
        });
    };

    return {
        init : init
    };
})();

module.exports = Accordion;

},{"../utils/matches.js":21}],3:[function(require,module,exports){
// Contenttable Module
const Contenttable = (function() {
    const getI18n = require('../utils/get-i18n.js');
    const matches = require('../utils/matches.js');
    const contenttables = [].slice.call(document.querySelectorAll('table'));

    const wrapTable = table => {
        let wrapper = document.createElement('div');

        wrapper.classList.add('contenttable-wrapper');
        wrapper.dataset.jsContenttable = 'wrapper';
        wrapper.dataset.jsI18n = 'Faites glisser,Swipe';
        wrapper.setAttribute('role', 'group');

        table.dataset.jsContenttable = 'table';
        table.insertAdjacentElement('afterend', wrapper);

        return wrapper.appendChild(table);
    };

    const setAsScrollable = (table, parent) => {
        let scrollable = table.clientWidth > parent.clientWidth;
        const scrollableIco = `<div class="contenttable-ico"><span class="visuallyhidden">${getI18n(parent)} </span><svg aria-hidden="true" role="img" class="ico-swipe"><use xlink:href="#ico_swipe"></use></svg></div>`;

        scrollable && parent.insertAdjacentHTML('beforebegin', scrollableIco);
        scrollable && parent.setAttribute('tabindex', '0');

        return;
    };

    const init = () => {
        contenttables.forEach(table => {
            wrapTable(table);
            setAsScrollable(table, table.parentNode);
        });
    };

    return {
        init : init
    };
})();

module.exports = Contenttable;

},{"../utils/get-i18n.js":17,"../utils/matches.js":21}],4:[function(require,module,exports){
// Dialog Module
const Dialog = (function() {
    const triggerCustomEvent = require('../utils/trigger-custom-event.js');
    const getClosest = require('../utils/get-closest.js');

    const setDialogTrigger = (trigger, uniqueID) => {
        // Add an id attribute if there's none
        if (trigger.id === "") {
            trigger.id = `dialogTrigger_${uniqueID}`;
        }

        return;
    };

    // Create the dialog element
    const setDialogElement = (trigger, content, uniqueID) => {
        const dialogElement = document.createElement('div');

        dialogElement.classList.add(
            'dialog',
            // Add a modifier class for custom styling
            `${(content.classList[0] ? content.classList[0] + '-dialog' : 'dialog--' + content.id)}`
        );
        dialogElement.setAttribute('aria-labelledby', trigger.id);
        dialogElement.setAttribute('aria-hidden', 'true');
        dialogElement.setAttribute('hidden', '');
        dialogElement.setAttribute('role', 'dialog');
        dialogElement.setAttribute('tabindex', '0');

        // Add an id attribute if there's none
        if (dialogElement.id === "") {
            dialogElement.id = `dialogModal_${uniqueID}`;
        }

        return dialogElement;
    };

    // Set dialog's close button
    const setDialogCloseButton = (dialog, trigger) => {
        const closeButton = document.createElement('button');
        const closeButtonIco = '<svg aria-hidden="true" role="img" class="ico-close"><use xlink:href="#ico_close"></use></svg>';
        const closeButtonText = '<span class="visuallyhidden">Fermer</span>';

        closeButton.classList.add('dialog__close', 'button-reset');
        closeButton.id = 'dialogClose';
        closeButton.innerHTML = closeButtonText + closeButtonIco;
        closeButton.setAttribute('type', 'button');
        closeButton.addEventListener('click', evt => {
            if (!dialog.hidden) {
                return toggleDialog(dialog, trigger, false);
            }

            return null;
        });

        return closeButton;
    };

    // Set dialog's content
    const setDialogContent = (content, dialog, trigger) => {
        content.appendChild(setDialogCloseButton(dialog, trigger));
        content.classList.add('dialog__content');

        return dialog.appendChild(content);
    };

    // Set visibility state as *visible*
    // @return node with different attributes
    const setDialogAsVisible = (dialog, trigger, scrollbar) => {
        dialog.removeAttribute('hidden');
        dialog.setAttribute('aria-hidden', 'false');

        // Give the focus to the dialog
        dialog.focus();

        // Remove the scrollbar
        if (!scrollbar) {
            document.body.style.overflow = 'hidden';
        }

        return;
    };

    // Set visibility state as *hidden*
    // @return node with different attributes
    const setDialogAsHidden = (dialog, trigger) => {
        dialog.setAttribute('hidden', '');
        dialog.setAttribute('aria-hidden', 'true');

        // Return the focus to the trigger
        trigger.focus();

        // Restore the body's scrollbar
        document.body.style.overflow = 'auto';

        return;
    };

    const toggleDialog = (dialog, trigger, scrollbar) => {
        if (dialog.hidden) {
            // Show the dialog
            setDialogAsVisible(dialog, trigger, scrollbar);
        } else {
            // Hide the dialog
            setDialogAsHidden(dialog, trigger);
        }

        triggerCustomEvent(dialog, 'dialogpop', { isVisible: !dialog.hidden, triggerNode: trigger, dialogNode: dialog});

        return;
    };

    // Initialize a dialog modal
    const init = (dialogTrigger, dialogContent, scrollbar) => {
        const uniqueID = Date.now().toString().slice(-8);
        const dialog = setDialogElement(dialogTrigger, dialogContent, uniqueID);
        const focusTrap = require('../utils/a11y/focus-trap.js');

        setDialogTrigger(dialogTrigger, uniqueID);
        setDialogContent(dialogContent, dialog, dialogTrigger);

        // Inject the dialog at the end of the body
        document.body.appendChild(dialog);

        // Set the focus trap in the `dialog`
        focusTrap.init(dialog);

        // When clicked
        dialogTrigger.addEventListener('click', evt => {
            evt.preventDefault();

            return toggleDialog(dialog, evt.currentTarget, scrollbar);
        });

        // When escaped
        document.addEventListener('keydown', evt => {
            if ((evt.keyCode || evt.which) === 27
                && !dialog.hidden) {
                evt.preventDefault();
                return toggleDialog(dialog, dialogTrigger, scrollbar);
            }

            return null;
        });

        // When clicked outside
        document.body.addEventListener('click', evt => {
            if (!getClosest(evt.target, `#${dialogTrigger.id}`)
                && !getClosest(evt.target, `#${dialog.id}`)
                && !dialog.hidden) {
                evt.stopPropagation();

                return toggleDialog(dialog, dialogTrigger, scrollbar);
            }

            return null;
        });
    };

    return {
        init : init,
        close : setDialogAsHidden
    };
})();

module.exports = Dialog;

},{"../utils/a11y/focus-trap.js":13,"../utils/get-closest.js":16,"../utils/trigger-custom-event.js":23}],5:[function(require,module,exports){
// Facets module
const Facets = (function() {
    const collapsible = require('../utils/collapsible.js');
    const facets = document.getElementById('facets');
    const isSmallScreen = require('../utils/is-smallscreen.js');
    const matches = require('../utils/matches.js');

    const setFacetsDialog = () => {
        const facetsTitle = document.querySelector('#facetsTitle');
        const facetsTitleClone = facetsTitle.cloneNode(true);
        const facetsWrapper = document.querySelector('[data-js-facets="wrapper"]');

        let facetsDialogFragment = document.createDocumentFragment();
        let facetsDialogTrigger = document.createElement('button');

        facetsDialogTrigger.id = 'facetsDialogTrigger';
        facetsDialogTrigger.innerHTML = facetsTitle.innerHTML;
        facetsDialogTrigger.setAttribute('type', 'button');

        facetsTitle.innerHTML = '';
        facetsTitle.appendChild(facetsDialogTrigger);

        facetsTitleClone.removeAttribute('id');

        if (isSmallScreen()) {
            facetsWrapper.insertAdjacentElement('afterbegin', facetsTitleClone);
        } else {
            facetsDialogFragment.appendChild(facetsTitleClone);
        }

        return;
    };

    const setFacetsDialogButtons = () => {
        const buttons = [
            document.querySelector('[data-js-facets="btncancel"]'),
            document.querySelector('[data-js-facets="btnfilter"]')
        ];

        return buttons.forEach(button => {
            button.addEventListener('click', evt => {
                matches(evt.target.parentNode.nextElementSibling, '#dialogClose')
                    && evt.target.parentNode.nextElementSibling.click();
            });
        });
    };

    const setFacetsCollapsible = () => {
        const facetsTitle = facets.querySelectorAll('[data-js-facets="grouptitle"]');
        const facetsList = facets.querySelectorAll('[data-js-facets="grouplist"]');
        // Set facets hidden by default
        facetsList.forEach(list => {
            return list.hidden = true;
        });

        // Init the show/hide mecanism
        return collapsible(facetsTitle, facetsList);
    };

    const init = () => {
        const dialog = require('./dialog.js');

        if (facets && isSmallScreen()) {
            setFacetsDialog();

            dialog.init(
                document.querySelector('#facetsDialogTrigger'),
                document.querySelector('#facets')
            );

            setFacetsDialogButtons();
        }

        setFacetsCollapsible();

        return;
    };

    return {
        init : init
    };
})();

module.exports = Facets;

},{"../utils/collapsible.js":15,"../utils/is-smallscreen.js":20,"../utils/matches.js":21,"./dialog.js":4}],6:[function(require,module,exports){
// Form Module
const Form = (function() {
    const isElement = require('../utils/is-element.js');
    const forms = [].slice.call(document.querySelectorAll('[data-js-form="form"]'));

    const getRequiredFields = form => {
        return [].slice.call(form.querySelectorAll(':required'));
    };

    const getFormControls = form => {
        return [].slice.call(form.querySelectorAll('input:not([type="hidden"]), select, textarea'));
    };

    const toggleHelpText = field => {
        let help;

        if (field.hasAttribute('aria-describedby')) {
            help = document.getElementById(field.getAttribute('aria-describedby'));

            if (field.checkValidity()) {
                help.hidden = true;
                field.classList.contains('is-invalid') && field.classList.remove('is-invalid');
            } else {
                help.hidden = false;
                !field.classList.contains('is-invalid') && field.classList.add('is-invalid');
            }

            if (help.getAttribute('data-js-form-invalid') !== '') {
                help.innerHTML = help.getAttribute('data-js-form-invalid');
            }
        }

        return;
    };

    // Initialize method
    const init = () => {
        forms.forEach(form => {
            // JIT validation
            getRequiredFields(form).forEach(field => {
                field.addEventListener('blur', evt => {
                    toggleHelpText(evt.target);
                });

                field.addEventListener('input', evt => {
                    toggleHelpText(evt.target);
                });
            });

            // Submit validation
            form.querySelector('[type="submit"]')
                .addEventListener('click', evt => {
                    getRequiredFields(form).forEach(field => {
                        toggleHelpText(field);
                    });
                });
        });

        return;
    };

    return {
        init : init
    };
})();

module.exports = Form;

},{"../utils/is-element.js":19}],7:[function(require,module,exports){
// Format date Module
const FormatHumanDate = (function () {

    const newsdate = [].slice.call(document.querySelectorAll(".date-news"));

    //Time units must be be ordered largest -> smallest
    const time_units = time_units || [
        [29030400, 'years'],
        [2419200, 'months'],
        [604800, 'weeks'],
        [86400, 'days'],
        [3600, 'hours'],
        [60, 'minutes'],
        [1, 'seconds']
    ];

    const tense = 'past';

    const humanized_time_span = (date, ref_date, date_formats, time_units) => {
        //Date Formats must be be ordered smallest -> largest and must end in a format with ceiling of null
        date = new Date(date);
        // date à l'instant T
        ref_date = ref_date ? new Date(ref_date) : new Date();

        let seconds_difference = (ref_date - date) / 1000;

        return render_date(get_format(seconds_difference), seconds_difference);
    };

    const get_format = (seconds_difference) => {
        for (var i = 0; i < date_formats[tense].length; i++) {
            if (date_formats[tense][i].ceiling == null || seconds_difference <= date_formats[tense][i].ceiling) {
                return date_formats[tense][i];
            }
        }
        return null;
    };

    const get_time_breakdown = (seconds_difference) => {
        var seconds = seconds_difference;
        var breakdown = {};
        for (var i = 0; i < time_units.length; i++) {
            var occurences_of_unit = Math.floor(seconds / time_units[i][0]);
            seconds = seconds - (time_units[i][0] * occurences_of_unit);
            breakdown[time_units[i][1]] = occurences_of_unit;
        }
        return breakdown;
    };

    const render_date = (date_format, seconds_difference) => {
        var breakdown = get_time_breakdown(seconds_difference);
        var time_ago_text = date_format.text.replace(/\$(\w+)/g, function () {
            return breakdown[arguments[1]];
        });
        return depluralize_time_ago_text(time_ago_text, breakdown);
    };

    const depluralize_time_ago_text = (time_ago_text, breakdown) => {
        for (var i in breakdown) {
            if (breakdown[i] == 1) {
                var regexp = new RegExp("\\b" + i + "\\b");
                time_ago_text = time_ago_text.replace(regexp, function () {
                    return arguments[0].replace(/s\b/g, '');
                });
            }
        }
        return time_ago_text;
    };

    // Initialize method
    const init = () => {
        newsdate.forEach(e => {
            let tense = 'past';
            e.innerHTML = humanized_time_span(e.dataset.dateParution);
        });


    };

    return {
        init: init
    };
})();

module.exports = FormatHumanDate;


// source script: https://github.com/GrouchPotato/js_humanized_time_span

},{}],8:[function(require,module,exports){
// MenuActions module
const MenuActions = (function() {
    const menu = document.getElementById('menuActions');
    const collapsible = require('../utils/collapsible.js');
    const isElement = require('../utils/is-element.js');

    const setMenuTriggerButton = (trigger) => {
        let button = trigger.querySelector('button');
        let buttonIco = '<svg aria-hidden="true" class="ico-chevrondown"><use href="#ico_chevrondown"></use></svg>';

        button.classList.add('menu-actions__button');
        button.insertAdjacentHTML('beforeend', buttonIco);
        button.setAttribute('aria-controls', 'menuActionsPanel');
        button.setAttribute('aria-haspopup', 'true');

        return;
    };

    const setMenuPanel = (panel) => {
        // Hide the menu panel by default
        return panel.hidden = true;
    };

    const init = () => {
        let menuTrigger;
        let menuPanel;

        if (isElement(menu)) {
            menuTrigger = menu.querySelectorAll('[data-js-menu-actions="trigger"]');
            menuPanel = menu.querySelectorAll('[data-js-menu-actions="panel"]');

            setMenuPanel(menuPanel[0]);
            collapsible(menuTrigger, menuPanel, true);
            setMenuTriggerButton(menuTrigger[0]);

            menu.addEventListener('collapse', evt => {
                const open = 'menu-actions--open';

                if (evt.detail.isExpanded) {
                    evt.currentTarget.classList.add(open);
                } else {
                    evt.currentTarget.classList.remove(open);

                }
            });

            return;
        }

        return;
    };

    return {
        init : init
    };
})();

module.exports = MenuActions;

},{"../utils/collapsible.js":15,"../utils/is-element.js":19}],9:[function(require,module,exports){
// TOC navigation module
const NavTOC = (function() {
    const navToc = document.querySelector('[data-js-toc=""]');
    const throttle = require('../utils/throttle.js');
    let hasExecuted = false;

    // Close the TOC if it's at the edge of the window
    const collapseAtTheEdge = () => {
        const trigger = navToc.querySelector('[data-js-accordion="trigger"]');
        const isExpanded = (trigger.getAttribute('aria-expanded') === "true");
        const isAtTop = (navToc.getBoundingClientRect().top === 0);

        if (isExpanded && isAtTop && !hasExecuted) {
            hasExecuted = true;

            return setTimeout(() => {
                trigger.click();
            }, 500);
        }

        return null;
    };

    // Initialize method
    const init = () => {
        if (navToc) {
            return window.addEventListener('scroll', evt => {
                requestAnimationFrame(collapseAtTheEdge);
            });
        }

        return null;
    };

    return {
        init : init
    };
})();

module.exports = NavTOC;

},{"../utils/throttle.js":22}],10:[function(require,module,exports){
// Main navigation module
const Nav = (function() {
    const collapsible = require('../utils/collapsible.js');
    const find = require('../utils/array-find.js');
    const getClosest = require('../utils/get-closest.js');
    const getSiblings = require('../utils/get-siblings.js');
    const getI18n = require('../utils/get-i18n.js');
    const matches = require('../utils/matches.js');
    const nav = document.querySelector('nav#n');
    const mqLg = window.getComputedStyle(document.documentElement).getPropertyValue('--grd-lg') || '1280px';

    // Create a close button for the mobile panel
    // @return a HTMLButtonElement
    const setCloseButton = () => {
        const burger = nav.querySelector('#burger');
        const close = nav.querySelector('[data-js-nav="close"]');
        let closeButton = document.createElement('button');

        closeButton.classList.add('nav__close');
        closeButton.dataset.jsNav = 'close';
        closeButton.innerHTML = close.innerHTML;
        closeButton.setAttribute('type', 'button');
        closeButton.addEventListener('click', () => {
            burger.click();
            burger.focus();
        });

        close.insertAdjacentElement('afterend', closeButton);

        if (close.parentNode) {
            close.parentNode.removeChild(close);
        }

        return;
    };

    // Create a back button for the subpanels
    // @return a HTMLButtonElement
    const setBackButton = () => {
        const back = nav.querySelector('[data-js-nav="back"]');
        const backString = getI18n(back);
        let backIco = '<svg aria-hidden="true" role="img" class="ico-back ico-back--xs" height="16px" width="9px"><use xlink:href="#ico_navmobilenext"></use></svg>';
        let backIcoLgScreen = '<svg aria-hidden="true" role="img" class="ico-back ico-back--lg" height="13px" width="13px"><use xlink:href="#ico_close"></use></svg>';
        let backButton = document.createElement('button');

        backButton.classList.add('nav__back');
        backButton.innerHTML = `${backIco} ${backIcoLgScreen} <span class="visuallyhidden--lg">${backString}</span>`;
        backButton.setAttribute('type', 'button');
        backButton.addEventListener('click', evt => {
            const expander = find(
                getSiblings(evt.currentTarget.parentNode),
                sibling => matches(sibling, '[data-js-nav*="expander"]')
            );

            expander.click();
            expander.focus();
        });

        return backButton;
    };

    // @return a HTMLButtonElement
    const setSearchButton = () => {
        const burger = nav.querySelector('#burger');
        const searchLink = nav.querySelector('[data-js-nav="searchlink"]');
        const searchField = nav.querySelector('[data-js-nav="search"] [type="search"]');
        let searchButton = document.createElement('button');

        searchButton.classList.add('nav__search-button');
        searchButton.dataset.jsNav = 'expander index searchbutton';
        searchButton.innerHTML = searchLink.innerHTML;
        searchButton.setAttribute('type', 'button');
        searchButton.addEventListener('click', evt => {
            burger.click();
            searchField.focus();
        });

        if (searchLink.parentNode) {
            searchLink.parentNode.removeChild(searchLink);
        }

        return searchButton;
    };

    // Clone the secondary navigation for large screen
    const setLgScreenNavSecondary = () => {
        const navSecondaryClone = nav.querySelector('[data-js-nav="secondary"]').cloneNode(true);

        navSecondaryClone.setAttribute('aria-hidden', 'true');

        return document.querySelector('[data-js-header=""]')
            .insertAdjacentElement('beforeend', navSecondaryClone);
    };


    // Clone the search form for large screen
    const setLgScreenSearch = () => {
        const searchClone = document.querySelector('[data-js-nav="search"]').cloneNode(true);
        const searchCloneParent = document.querySelector('[data-js-nav="item search"]');

        // Change attributes of the search
        searchClone.setAttribute('aria-hidden', 'true');
        searchClone.classList.add('nav__expandable--lev-1');
        searchClone.dataset.jsNav = 'expandable';

        return searchCloneParent.insertAdjacentElement('beforeend', searchClone);
    };

    // Small screens specificities
    // Create the mecanism to open/close the mobile navigation
    const setSmScreenNav = () => {
        const burger = nav.querySelector('[data-js-nav="burger"]');
        const mobilePanel = nav.querySelector('[data-js-nav="panel"]');

        // Removes the ancor element
        burger.innerHTML = burger.querySelector('a').innerHTML;

        // Hide de mobilePanel by default
        mobilePanel.hidden = true;

        // Init the show/hide mecanism
        collapsible([burger], [mobilePanel]);

        // Set the burger button
        burger.querySelector('button').className = 'nav__burger';
        burger.querySelector('button').id = 'burger';

        // Insert the search button
        nav.insertAdjacentElement('afterbegin', setSearchButton());

        // Insert the close button
        setCloseButton();

        return;
    };

    // Presets expander button
    // @return a HTMLElement
    const setExpander = expandable => {
        const expander = find(getSiblings(expandable), sibling => matches(sibling, '[data-js-nav*="expander"]'));
        const newExpanderIco = '<svg aria-hidden="true" role="img" class="ico-navmobilenext"><use xlink:href="#ico_navmobilenext"></use></svg>';
        let newExpander = document.createElement('button');

        newExpander.className = expander.className;
        newExpander.dataset.jsNav = expander.dataset.jsNav;
        newExpander.innerHTML = `<span>${expander.innerHTML}</span>${newExpanderIco}`;
        newExpander.setAttribute('aria-expanded', `${!expandable.hasAttribute('hidden')}`);

        // Insert the new remove the old
        expander.insertAdjacentElement('afterend', newExpander);
        expander.parentNode.removeChild(expander);

        return newExpander;
    };

    // Get all expandables
    // @return array of HTMLElement
    const getExpandables = parent => {
        return [].slice.call(parent.querySelectorAll('[data-js-nav="expandable"]'));
    };

    // Presets expandables before apply the collapsible function
    // @return an array of HTMLElement
    const setExpandables = expandables => {
        return expandables.map(expandable => {
            expandable.classList.add('nav__expandable');

            // Hide by default
            expandable.setAttribute('hidden', '');

            // Add the back button
            expandable.insertAdjacentElement('afterbegin', setBackButton(expandable));

            return expandable;
        });
    };

    // Get the siblings of an expandable
    // @return array of HTMLElement
    const getExpandableSiblings = expandable => {
        // Set an array of children (`[data-js-nav="item"]`) of the grand parent node
        // But not the parent of the `expandable`
        const siblingsParent = getSiblings(expandable.parentNode);

        // Then return the `[data-js-nav="expandable"]` of those siblings
        return siblingsParent.map(parent => {
            return parent.querySelector('[data-js-nav="expandable"]') !== null
                && parent.querySelector('[data-js-nav="expandable"]');
        });
    };

    // Set visibility state as *visible*
    // @return nodes with different attributes
    const setExpandableAsVisible = (expandable, expanderButton) => {
        if (expandable) {
            expandable.removeAttribute('hidden');
            expandable.previousElementSibling.setAttribute('aria-expanded', 'true');

            if (expanderButton) {
                expanderButton.setAttribute('aria-expanded', 'true');
            } else {
                expandable.previousElementSibling.setAttribute('aria-expanded', 'true');
            }
        }

        return;
    };

    // Set visibility state as *hidden*
    // @return nodes with different attributes
    const setExpandableAsHidden = (expandable, expanderButton) => {
        if (expandable) {
            expandable.setAttribute('hidden', '');

            if (expanderButton) {
                expanderButton.setAttribute('aria-expanded', 'false');
            } else {
                expandable.previousElementSibling.setAttribute('aria-expanded', 'false');
            }
        }

        return;
    };

    // Change expandable height if one of his children is higher
    const setHigherExpanded = () => {
        const expanded = getExpandables(nav).filter(expandable => {
            return matches(expandable, ':not([hidden])');
        });
        const heights = expanded.map(expandable => expandable.querySelector('[data-js-nav="list"]').getBoundingClientRect().height);

        return expanded.forEach(expandable => {
            if (Math.max.apply(Math, heights) > expandable.getBoundingClientRect().height) {
                expandable.style.height = `${Math.max.apply(Math, heights) + 32}px`;
            }
        });
    };

    // Toggle visibility state between *visible* & *hidden*
    // @return nodes with different attributes
    const toggleExpandableVisibilityState = (expanderButton, expandable, callback) => {
        expanderButton.addEventListener('click', evt => {
            if (expandable.hidden) {
                setExpandableAsVisible(expandable, expanderButton);
            } else {
                setExpandableAsHidden(expandable, expanderButton);
            }

            callback && callback(evt);
        });

        return;
    };

    // Mark the first and the last expanded expandables
    const markFirstLastExpanded = () => {
        const expanded = getExpandables(nav).filter(expandable => {
            return matches(expandable, ':not([hidden])');
        });
        const first = expanded[0];
        const last = expanded.slice(-1)[0];
        const firstState = 'is--first';
        const lastState = 'is--last';

        if (first !== last) {
            first.classList.add(firstState);
            last.classList.add(lastState);
        } else if (first && first === last) {
            first.classList.add(firstState);
            last.classList.add(lastState);
        }

        // Hack to set a background-color
        if (!window.matchMedia(`screen and (min-width: ${mqLg})`).matches && last) {
            setExpandableBgColorToPanel(last);
        }

        return expanded.map(e => {
            e !== first && e.classList.remove(firstState);
            e !== last && e.classList.remove(lastState);
        });
    };

    // Set the current expandable background color to the navigation panel
    const setExpandableBgColorToPanel = expandable => {
        const currentExpandableColor = window.getComputedStyle(expandable).backgroundColor;

        return nav.querySelector('[data-js-nav="panel"]').style.background = currentExpandableColor;
    };

    // Initialize method
    const init = () => {
        const isSmallScreen = require('../utils/is-smallscreen.js');
        let screenSize = (isSmallScreen() ? 'smallscreen' : 'largescreen');
        setSmScreenNav();
        setLgScreenNavSecondary();
        setLgScreenSearch();

        setExpandables(getExpandables(nav)).forEach((expandable, i, arr) => {
            // Then listen the `expanderButton`
            toggleExpandableVisibilityState(setExpander(expandable), expandable, () => {
                // Close siblings of this expandable
                getExpandableSiblings(expandable).forEach(sibling => {
                    if (sibling) {
                        // And all the children of the sibling
                        getExpandables(sibling).forEach(child => setExpandableAsHidden(child));
                    }

                    return setExpandableAsHidden(sibling);
                });

                // The first & the last are identified with classes
                markFirstLastExpanded();

                // Ajust the height to bypass the vertical scroll
                if (window.matchMedia(`screen and (min-width: ${mqLg})`).matches) {
                    setHigherExpanded();
                }

                return;
            });
        });

        document.body.addEventListener('collapse', evt => {
            let currentClassList = evt.currentTarget.classList;

            // Add a class to document.body when the nav panel is open
            if (evt.detail.isExpanded
                && matches(evt.detail.triggerNode, '#burger')
                && !currentClassList.contains('nav-is-open')) {
                currentClassList.add('nav-is-open');
            }

            // Remove a class to document.body when the nav panel is close
            if (!evt.detail.isExpanded
                && matches(evt.detail.triggerNode, '#burger')
                && currentClassList.contains('nav-is-open')) {
                currentClassList.remove('nav-is-open');
            }
        });

        // When clicking outside
        document.addEventListener('click', evt => {
            const isClickedOutside = !nav.querySelector('[data-js-nav="panel"]').contains(evt.target);

            // Close all expandables when clicked outside de navigation panel
            return isClickedOutside
                && getExpandables(nav).forEach(expandable => setExpandableAsHidden(expandable));
        });

        // When escape
        document.body.addEventListener('keydown', evt => {
            if ((evt.keyCode || evt.which) === 27) {
                evt.preventDefault();

                return getExpandables(nav).forEach(expandable => setExpandableAsHidden(expandable));
            }

            return null;
        });

        // When window resizing
        window.onresize = () => {
            let screenSizeNow = (isSmallScreen() ? 'smallscreen' : 'largescreen');

            if (screenSizeNow !== screenSize) {
                getExpandables(nav).forEach(expandable => setExpandableAsHidden(expandable));

                return screenSize = screenSizeNow;
            }

            return null;
        };
    };

    return {
        init : init
    };
})();

module.exports = Nav;

},{"../utils/array-find.js":14,"../utils/collapsible.js":15,"../utils/get-closest.js":16,"../utils/get-i18n.js":17,"../utils/get-siblings.js":18,"../utils/is-smallscreen.js":20,"../utils/matches.js":21}],11:[function(require,module,exports){
const ScrollTop = (function() {
    const buttonscrollTop = document.querySelector('[data-js-scrolltop=""]');

    const init = () => {
        const isElement = require('../utils/is-element.js');
        const toggleScrollTo = () => {
            const viewportHeight = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);

            if (window.scrollY > viewportHeight) {
                buttonscrollTop.removeAttribute('hidden', '');
            } else {
                buttonscrollTop.setAttribute('hidden', '');
            }

            return;
        };

        if (isElement(buttonscrollTop)) {
            toggleScrollTo();

            return window.addEventListener('scroll', evt => {
                requestAnimationFrame(toggleScrollTo);
            });
        }

        return null;
    };

    return {
        init : init
    };
})();

module.exports = ScrollTop;

},{"../utils/is-element.js":19}],12:[function(require,module,exports){
// Share content to social media & co.
const Share = (function() {
    const share = document.querySelector('[data-js-share=""]');
    const facebook = `<a class="button-round button-round--facebook" href="https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(document.URL)}" target="_blank" title="Facebook"><span>Facebook</span><svg aria-hidden="true" role="img" class="ico-facebook"><use xlink:href="#ico_facebook"></use></svg></a>`;
    const twitter = `<a class="button-round button-round--twitter"href="https://twitter.com/share?url=${encodeURIComponent(document.URL)}&text=${encodeURIComponent(document.title)}" target="_blank"title="Twitter"><span>Twitter</span><svg aria-hidden="true" role="img" class="ico-twitter"><use xlink:href="#ico_twitter"></use></svg></a>`;
    const linkedin = `<a class="button-round button-round--linkedin" href="https://www.linkedin.com/shareArticle?url=${encodeURIComponent(document.URL)}&title=${encodeURIComponent(document.title)} "target="_blank"title="LinkedIn"><span>Linkedin</span><svg aria-hidden="true" role="img" class="ico-linkedin"><use xlink:href="#ico_linkedin"></use></svg></a>`;
    const mail = `<a class="button-round button-round--email"href="mailto:?body=${encodeURIComponent(document.URL)}%0A%0A${encodeURIComponent(document.querySelector('meta[name=description]')?document.querySelector('meta[name=description]').content:'')}&subject=${encodeURIComponent(document.title)}" title="Mail"><span>Email</span><svg aria-hidden="true" role="img" class="ico-courriel"><use xlink:href="#ico_courriel"></use></svg></a>`;
    const link = `<div class="share__copy-link" data-js-share="linkwrapper"><button class="button-round button-round--link" type="button" data-js-share="link" data-js-i18n="Lien copié,Link copied"><svg aria-hidden="true" role="img" class="ico-sharelink"><use xlink:href="#ico_sharelink"></use></svg><span>Copier le lien</span></button><div aria-live="polite" role="status"></div></div>`;
    const print = `<button class="button-round button-round--print" type="button" data-js-share="print"><span>Imprimer</span><svg aria-hidden="true" role="img" class="ico-imprime"><use xlink:href="#ico_imprime"></use></svg></button>`;

    const setButtons = (fnCallback) => {
        const medias = [facebook, twitter, linkedin, mail, link, print];
        const menu = share.querySelector('[data-js-share="menu"]');

        medias.forEach(media => {
            menu.insertAdjacentHTML('beforeend', media);
        });

        return fnCallback();
    };

    const printPg = () => {
        const button = share.querySelector('[data-js-share="print"]');

        return button.addEventListener('click', () => window.print());
    };

    const copyURL = () => {
        const getI18n = require('../utils/get-i18n.js');
        const button = share.querySelector('[data-js-share="link"]');
        const wrapper = share.querySelector('[data-js-share="linkwrapper"]');
        const status = wrapper.querySelector('[role*="status"]');
        const url = window.location.href;
        const textarea = document.createElement('textarea');

        // Hidden and filled it
        textarea.className = 'visuallyhidden';
        textarea.innerHTML = window.location.href;

        // Append the hidden textarea
        share.appendChild(textarea);

        // Then copy
        button.addEventListener('click', evt => {
            textarea.focus();
            textarea.select();

            // Copy execution
            document.execCommand('copy');

            // Show the status message
            status.innerHTML = getI18n(button);

            // Then hides it after 3 seconds
            return setTimeout(() => {
                status.innerHTML = '';
            }, 3000);
        });

        return;
    };

    const init = () => {
        if (share) {
            setButtons(() => {
                printPg();
                copyURL();
            });
        }

        return;
    };

    return {
        init : init
    };
})();

module.exports = Share;

},{"../utils/get-i18n.js":17}],13:[function(require,module,exports){
// Focus Trap Module
const FocusTrap = (function() {
    function init(element) {
        const focusableEls = [].slice.call(element.querySelectorAll('a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])'));
        const firstFocusableEl = focusableEls[0];
        const lastFocusableEl = focusableEls[focusableEls.length - 1];
        const KEYCODE_TAB = 9;

        element.addEventListener('keydown', function(e) {
            let isTabPressed = (e.key === 'Tab' || e.keyCode === KEYCODE_TAB);

            if (!isTabPressed) {
                return;
            }

            if (e.shiftKey) /* shift + tab */ {
                if (document.activeElement === firstFocusableEl) {
                    lastFocusableEl.focus();
                    e.preventDefault();
                }
            } else /* tab */ {
                if (document.activeElement === lastFocusableEl) {
                    firstFocusableEl.focus();
                    e.preventDefault();
                }
            }
        });
    }

    return {
        init: init
    };
})();

module.exports = FocusTrap;

},{}],14:[function(require,module,exports){
'use strict';
/**
 * Find array elements. Executes a callback for each element, returns
 * the first element for which its callback returns a truthy value.
 * @return {Element} The value of the first element in the array that satisfies the provided testing function
 * @source <https://github.com/stefanduberg/array-find>
 */
module.exports = (array, predicate, context) => {
    if (typeof Array.prototype.find === 'function') {
        return array.find(predicate, context);
    }

    context = context || this;
    var length = array.length;
    var i;

    if (typeof predicate !== 'function') {
        throw new TypeError(predicate + ' is not a function');
    }

    for (i = 0; i < length; i++) {
        if (predicate.call(context, array[i], i, array)) {
            return array[i];
        }
    }

    return null;
};

},{}],15:[function(require,module,exports){
// Collapsible block utility
// @param {NodeList|Array} `triggerNodes` Nodes whom triggers the collapsible targets
// @param {NodeList|Array} `targetNodes` Nodes that are collapsible
// @param {Boolean} `closable` If true it closes when clicking outside
// @return {Nodes} Modified nodes
// @usage Collapsible(document.querySelectorAll(myTriggerSelector), document.querySelectorAll(myTargetSelector));
module.exports = (triggerNodes, targetNodes, closable) => {
    const getClosest = require('./get-closest.js');
    const triggerCustomEvent = require('./trigger-custom-event.js');
    const triggers = [].slice.call(
        (triggerNodes || document.querySelectorAll('[data-js-collapsible="trigger"]'))
    );
    const targets = [].slice.call(
        (targetNodes || document.querySelectorAll('[data-js-collapsible="target"]'))
    );

    const setTriggerExpandedClass = triggerNode => {
        const expandedClass = 'is--expanded';

        if (triggerNode.querySelector('button[aria-expanded]').getAttribute('aria-expanded') === 'true') {
            return triggerNode.classList.add(expandedClass);
        } else {
            return triggerNode.classList.contains(expandedClass) &&
                triggerNode.classList.remove(expandedClass);
        }

        return null;
    };

    const setClosableClasses = (triggerButton, target) => {
        triggerButton.dataset.jsClosable = 'trigger';
        target.dataset.jsClosable = 'target';

        return;
    };

    const closeExpandedClosable = () => {
        const expandedClosableTrigger = '[data-js-closable="trigger"][aria-expanded="true"]';
        const expandedClosableTarget = '[data-js-closable="target"]:not([hidden])';

        // When click outside
        document.body.addEventListener('click', evt => {
            if (!getClosest(evt.target, expandedClosableTrigger)
                && !getClosest(evt.target, expandedClosableTarget)) {
                evt.stopPropagation();

                [].slice.call(document.querySelectorAll(expandedClosableTrigger))
                    .forEach(expanded => {
                        expanded.click();
                    });
            }
        });

        // When escape
        document.body.addEventListener('keydown', evt => {
            if ((evt.keyCode || evt.which) === 27) {
                evt.preventDefault();

                [].slice.call(document.querySelectorAll(expandedClosableTrigger))
                    .forEach(expanded => {
                        expanded.click();
                    });
            }

            return;
        });
    };

    // The number of triggers & targets must be equivalent
    if (triggers.length === triggers.length
        && triggers.length > 0) {
        triggers.forEach((trigger, index) => {
            let target = targets[index];

            // Set a button into the declared `trigger`
            trigger.innerHTML = `<button aria-expanded="${!target.hasAttribute('hidden')}" data-js-collapsible="button" type="button">${trigger.innerHTML}</button>`;

            // Set a class if the aria-expanded is at true
            setTriggerExpandedClass(trigger);

            // Listen the click to expand/collapse the `target`
            trigger.querySelector('button').addEventListener('click', evt => {
                let expanded = evt.currentTarget.getAttribute('aria-expanded') === 'true';

                evt.preventDefault();
                evt.currentTarget.setAttribute('aria-expanded', !expanded);
                target.hidden = expanded;

                // Set a class if the aria-expanded is at true
                setTriggerExpandedClass(evt.currentTarget.parentNode);

                triggerCustomEvent(target, 'collapse', { isExpanded: !expanded, triggerNode: evt.currentTarget, targetNode: target});
            });

            // Only if closable is set to `true`
            if (closable) {
                setClosableClasses(trigger.querySelector('button'), target);
            }
        });

        // Only if closable is set to `true`
        if (closable) {
            closeExpandedClosable();
        }
    }

    return;
};

},{"./get-closest.js":16,"./trigger-custom-event.js":23}],16:[function(require,module,exports){
/**
 * Get the closest matching element up the DOM tree.
 * @param  {Element} elem     Starting element
 * @param  {String}  selector Selector to match against
 * @return {Boolean|Element}  Returns null if not match found
 * @source <https://gomakethings.com/climbing-up-and-down-the-dom-tree-with-vanilla-javascript/>
 */
module.exports = (elem, selector) => {
    const matches = require('./matches.js');

	// Get closest match
	for ( ; elem && elem !== document; elem = elem.parentNode ) {
		if ( matches( elem, selector ) ) return elem;
	}

	return null;
};

},{"./matches.js":21}],17:[function(require,module,exports){
/**
 * Get translation values of [dataset.jsI18n] and split it in a array
 * @param  {Element} elem with the [dataset.jsI18n] attribute
 * @return {String}  Returns a string base on the html[lang] value
 */
module.exports = elem => {
    const lang = document.querySelector('html').getAttribute('lang');
    const i18n = elem.dataset && elem.dataset.jsI18n.split(',');

    if (lang && i18n) {
        switch (lang) {
        case 'fr':
            return i18n[0];
            break;
        case 'en':
            return i18n[1];
        default:
            return i18n[0];
        }
    }

    return null;
};

},{}],18:[function(require,module,exports){
/**
 * Get the siblings of an element.
 * @param  {Element} elem Starting element
 * @return {Boolean|Array}  Returns null if not match found
 */
module.exports = elem => {  
	// Filter the children, exclude the element
    return [].slice.call(elem.parentNode.children).filter(child => {
        return child !== elem;
    });	
};

},{}],19:[function(require,module,exports){
// @param {Object} `obj` The item to test
// @return {Boolean} True if `obj` is an Node.ELEMENT_NODE
// @usage du.isElement(thatItem);
// @source <http://underscorejs.org/#isElement>
// @about Is a given value a DOM element
module.exports = (obj) => {
	return !!(obj && obj.nodeType === 1);
};

},{}],20:[function(require,module,exports){
// @return {Boolean} True if `window` is under mqLg
module.exports = () => {
  const mqLg = window.getComputedStyle(document.documentElement).getPropertyValue('--grd-lg') || '1280px';

	return !window.matchMedia(`screen and (min-width: ${mqLg})`).matches;
};

},{}],21:[function(require,module,exports){
/**
 * Matches Selector
 * @private
 * @param  {Element} elem Starting element
 * @param  {String}  selector Selector to match against
 * @return {Boolean} true if the element would be selected by the specified selector string; otherwise, returns false
 * @usage matches(elem, '.my-class');
 * @source <http://youmightnotneedjquery.com/>
 */

module.exports = (elem, selector) => {
    return (elem.matches
            || elem.matchesSelector
            || elem.msMatchesSelector
            || elem.mozMatchesSelector
            || elem.webkitMatchesSelector
            || elem.oMatchesSelector).call(elem, selector);
};

},{}],22:[function(require,module,exports){
// @param {Object} `fnCallback` The function to throttle
// @param {Number} `delay` The setTimeout delay in milisecond
// @return {Object} `fnCallback`
// @usage window.addEventListener('scroll', du.setThrottle(function(e) {...}, 50));
// @source <http://www.grafikart.fr/tutoriels/javascript/debounce-throttle-642>
// @about Reduce the amount of times a function can run
module.exports = (fnCallback, delay) => {
    var last;
    var timer;

    return function() {
        var context = this;
        var now = +new Date();
        var args = arguments;

        if (last && now < last + delay) {
            clearTimeout(timer);

            timer = setTimeout(function() {
                last = now;
                fnCallback.apply(context, args);
            }, delay);

        } else {
            last = now;

            fnCallback.apply(context, args);
        }
    };
};

},{}],23:[function(require,module,exports){
// @param {Node} `el` The base element
// @param {String} `eventType` The event type or name
// @param {Object} `eventData` The detail property. Data associated with the event
// @usage triggerCustomEvent(element, 'catdown', [myBigFatData, 'Hello Goodbye!']);
module.exports = (el, eventType, eventData) => {
    let customEvent;

    if (Event) {
        if (typeof Event.prototype.constructor === 'function') {
            customEvent = new Event(eventType, {
                bubbles: true
            });

            customEvent.detail = eventData;
        } else {
            customEvent = document.createEvent('CustomEvent');
            customEvent.initCustomEvent(eventType, true, true, eventData);
        }

        // Dispatch the event.
        return el.dispatchEvent(customEvent);
    }

    return null;
};

},{}]},{},[1]);
